import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { FilterPanel } from './FilterPanel';
import type { useProductFilters } from '../../hooks/useProductFilters';
type FilterApi = ReturnType<typeof useProductFilters>;
export function MobileFilterDrawer({
  open,
  onClose,
  api
}: {
  open: boolean;
  onClose: () => void;
  api: FilterApi;
}) {
  return <AnimatePresence data-id="element-644" data-mp="1rl9dpvrvhs5n">
      {open && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} className="fixed inset-0 z-50 bg-ink/40 lg:hidden" aria-hidden="true" data-id="element-645" data-mp="1rin5dtx5r8md" />
          <motion.div role="dialog" aria-modal="true" aria-label="Filters" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.28,
        ease: [0.32, 0.72, 0, 1]
      }} className="fixed left-0 top-0 z-50 flex h-full w-full max-w-sm flex-col bg-white lg:hidden" data-id="element-646" data-mp="1dnbbtpuqno71">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-647" data-mp="17og03h4i83yn">
              <h2 className="text-base font-bold text-ink" data-id="element-648" data-mp="ttchgzenderv">Filters</h2>
              <button type="button" onClick={onClose} aria-label="Filters sluiten" className="flex h-9 w-9 items-center justify-center rounded-lg hover:bg-surface" data-id="element-649" data-mp="yqmep18a2uq9">
                <XIcon className="h-5 w-5" data-id="element-650" data-mp="1rf1h8oa83kkp" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-5 py-5" data-id="element-651" data-mp="1cq596r8627k3">
              <FilterPanel api={api} data-id="element-652" data-mp="1cnrisvofljiv" />
            </div>
            <div className="flex gap-3 border-t border-line p-4" data-id="element-653" data-mp="1ho6wxpgjev1w">
              <button type="button" onClick={api.clearAll} className="h-11 flex-1 rounded-lg border border-line text-sm font-semibold text-ink" data-id="element-654" data-mp="25ejbhj6afq1g">
                Wissen
              </button>
              <button type="button" onClick={onClose} className="h-11 flex-[2] rounded-lg bg-ink text-sm font-semibold text-white" data-id="element-655" data-mp="2a72ks3xxzz0g">
                Toon {api.results.length} producten
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}